import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { FolioGuia } from "app/features/componentes/folioguia";

export interface Props {
    value: models.FiltroEntregaZE;
    onChange: (value: models.FiltroEntregaZE) => void;
}


/**
* Componente para editar un FiltroGuia
*/
class FiltroEntregaComponentNoRx extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<models.FiltroEntregaZE> {
        return {};
    }


    render() {
        const { value } = this.props;
        const getField = this.getField;

        const ChoferZE = getField(selectores.ChoferZE);

        return (
            <div>
                {kea.autogrid(6, [
                    <ChoferZE field="IdChofer" label="Chofer de zona extendida" />
                ])}
            </div>);
    }
}

export const FiltroEntregaComponent = componentToRx(FiltroEntregaComponentNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/liberacionentregasZE/components/multientregas/filtro.tsx